export default "__VITE_ASSET__d6a868ed__"